import React, {forwardRef} from 'react';
import {
  ModalActionTimerContainer,
  ModalActionTimerContent,
  ModalActionTimerHead,
  ModalActionTimerBody,
  ModalActionTimerBodyIcon,
  ModalActionTimerBodyLabel,
  ModalActionTimerBodyDescription,
  ModalActionTimerFooter,
  ModalActionTimerFooterButton,
  ModalActionTimerBodyTime
} from './styles';

const ModalActionTimer = forwardRef((props, ref) => {
  return (
    <ModalActionTimerContainer ref={ref}>
      <ModalActionTimerContent>
        <ModalActionTimerHead>
        </ModalActionTimerHead>
        <ModalActionTimerBody>
          <ModalActionTimerBodyIcon backgroundIcon={props.backgroundIcon}>
            {props.bodyIcon}
          </ModalActionTimerBodyIcon>
          <ModalActionTimerBodyLabel>
            {props.title}
          </ModalActionTimerBodyLabel>          
            <ModalActionTimerBodyDescription>
            <ModalActionTimerBodyTime ref={props.refTime}></ModalActionTimerBodyTime>
            </ModalActionTimerBodyDescription>         
        </ModalActionTimerBody>
        <ModalActionTimerFooter>
          {props.actionLabelFunctionUpButton && (
            <ModalActionTimerFooterButton onClick={() => props.actionFunctionUpButton()} id="top-action-button">
              {props.actionLabelFunctionUpButton}
            </ModalActionTimerFooterButton>
          )}
          {props.actionLabelFunctionDownButton && (
            <ModalActionTimerFooterButton onClick={() => props.actionFunctionDownButton()} id="bottom-action-button">
              {props.actionLabelFunctionDownButton}
            </ModalActionTimerFooterButton>
          )}
        </ModalActionTimerFooter>
      </ModalActionTimerContent>
    </ModalActionTimerContainer>
  )
})

export default ModalActionTimer
